<template>
    <div :class="classList">
        <el-button
            v-bind="$attrs"
            :type="type"
            class="presence__control-save"
            @click="$emit('click')"
        >
            <slot></slot>
        </el-button>

        <div v-if="pulse" class="v-button__rings"></div>
    </div>
</template>

<script>
export default {
    name: 'VButton',

    props: {
        pulse: {
            type: Boolean,
            default: false,
        },

        type: {
            type: String,
            default: '',
        },
    },

    computed: {
        classList() {
            return [
                'v-button',
                { [`_${this.type}`]: this.type },
            ];
        },
    },
}
</script>

<style lang="scss">
.v-button {
    position: relative;

    &._success {
        .v-button__rings {
            border-color: $success-clr;
            -webkit-box-shadow: 0px 0px 25px 0px $success-clr inset;
            -moz-box-shadow: 0px 0px 25px 0px $success-clr inset;
            box-shadow: 0px 0px 25px 0px $success-clr inset;
        }
    }
}

.v-button__rings {
  border: 1px solid transparent;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100;
  border-radius: 4px;
  animation-duration: 1.5s;
  animation-name: pulse;
  animation-iteration-count: infinite;
  z-index: -1;
  -webkit-box-shadow: 0px 0px 25px 0px rgb(14, 144, 244) inset;
  -moz-box-shadow: 0px 0px 25px 0px rgb(14, 144, 244) inset;
  box-shadow: 0px 0px 25px 0px rgb(14, 144, 244) inset;
}

@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(0.9, 0.9);
  }
 
  to {
    opacity: 0;
    transform: scale(1.3, 1.3);
  }
}
</style>